import { apiFetch } from '@/api/client'

export type UserInfo = {
  id: string
  email: string | null
  firstName: string | null
  lastName: string | null
  /** Roles as assigned in Keycloak, `ROLE_`-prefixed. */
  roles: string[]
  /** Expanded along `ADMIN > MANAGER > USER`. Use this for every "may they see this?" decision. */
  effectiveRoles: string[]
}

export function fetchUserInfo(): Promise<UserInfo> {
  return apiFetch<UserInfo>('/api/auth/userinfo')
}

export type VersionInfo = { name: string; version: string }

export function fetchVersion(): Promise<VersionInfo> {
  return apiFetch<VersionInfo>('/api/info/version')
}
